/**
 * A system's character (or army) builders as a section of their own: the tool a player opens
 * first, so it gets a tile with its name and site rather than a line in the sidebar.
 */
import { ExternalLink, Hammer } from 'lucide-react'
import type { Link as LinkT } from '../../shared/model'

const host = (url: string) => {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}

export function BuilderLinks({ title, links }: { title: string; links: LinkT[] }) {
  if (!links.length) return null
  return (
    <section className="section" aria-labelledby="builders-title">
      <h2 className="section-title" id="builders-title">
        {title}
      </h2>
      <ul className="builder-grid">
        {links.map((l) => (
          <li key={l.url}>
            <a href={l.url} target="_blank" rel="noopener noreferrer nofollow ugc" className="builder-tile">
              <Hammer size={20} aria-hidden="true" className="builder-icon" />
              <span className="builder-text">
                <span className="builder-name">{l.label || host(l.url)}</span>
                <span className="builder-host">{host(l.url)}</span>
              </span>
              <ExternalLink size={14} aria-hidden="true" className="builder-out" />
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
